import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

let isRefreshing: boolean = false;
let refreshSubscribers: any[] = [];

axios.interceptors.request.use(
    (config) => {
        const now = Math.round((new Date()).getTime() / 1000);
        if (store.state.tokenValidUntil <= now && store.state.tokenValidUntil !== 0) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('username');
            localStorage.removeItem('displayName');
            localStorage.removeItem('role');
            localStorage.removeItem('tokenValidUntil');
            router.push({ path: '/login' });
            store.state.infoBoxText = 'Sie wurden abgemeldet, da Sie längere Zeit nicht aktiv waren.';
        } else {
            const accessToken = localStorage.getItem('accessToken');
            if (accessToken) {
                const authorization = 'Authorization';
                config.headers.common[authorization] = 'Bearer ' + accessToken;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const { config, response: { status } } = error;
        const originalRequest = config;

        if (error.response.status !== 401) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        } else if (error.response.status === 401 && error.config.url === 'refresh') {
            store.dispatch('destroyToken')
            .then(() => {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('username');
                localStorage.removeItem('displayName');
                localStorage.removeItem('role');
                localStorage.removeItem('tokenValidUntil');
                router.push({ path: '/login' });
                store.state.infoBoxText = 'Sie wurden abgemeldet, da Sie längere Zeit nicht aktiv waren.';
            }).catch(() => {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('username');
                localStorage.removeItem('displayName');
                localStorage.removeItem('role');
                localStorage.removeItem('tokenValidUntil');
                router.push({ path: '/login' });
                store.state.infoBoxText = 'Sie wurden abgemeldet, da Sie längere Zeit nicht aktiv waren.';
            });
        } else if (error.response.status === 401) {
            if (!isRefreshing) {
                isRefreshing = true;
                store.dispatch('refreshAccessToken')
                .then((token) => {
                    isRefreshing = false;
                    refreshSubscribers.map((cb) => cb(token));
                    refreshSubscribers = [];
                })
                .catch((err) => {
                    Promise.reject(err);
                });
            }

            const retryOrigReq = new Promise((resolve, reject) => {
                refreshSubscribers.push((token: any) => {
                    const authorization = 'Authorization';
                    originalRequest.headers[authorization] = 'Bearer ' + token;
                    resolve(axios(originalRequest));
                });
            });
            return retryOrigReq;
        } else {
            return Promise.reject(error);
        }
    },
);


Vue.use(VueAxios, axios);

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
